import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, CopyIcon, ShareIcon } from 'lucide-react';
import { TopBar } from '../components/TopBar';
interface ReferralProgramProps {
  navigate: (screen: string) => void;
}
export function ReferralProgram({
  navigate
}: ReferralProgramProps) {
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} className="flex-1 overflow-y-auto pb-safe bg-slate-50" data-id="element-2589">
      <TopBar title="Referral Program" showBack onBack={() => navigate('profile')} data-id="element-2590" />

      <div className="px-5 pt-6 pb-8" data-id="element-2591">
        <div className="bg-[#0D3B3B] rounded-3xl p-6 text-center text-white mb-8 shadow-lg shadow-[#0D3B3B]/20 relative overflow-hidden" data-id="element-2592">
          <div className="absolute top-0 right-0 w-32 h-32 bg-[#FFD700]/20 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-2593"></div>

          <div className="w-16 h-16 rounded-full bg-[#FFD700] text-[#0D3B3B] flex items-center justify-center mx-auto mb-4 relative z-10 shadow-lg" data-id="element-2594">
            <GiftIcon className="w-8 h-8" data-id="element-2595" />
          </div>

          <h2 className="text-2xl font-black mb-2 relative z-10" data-id="element-2596">
            Invite & Earn
          </h2>
          <p className="text-sm text-white/80 mb-6 relative z-10" data-id="element-2597">
            Get ₦1,000 for every friend who signs up and completes KYC using
            your referral code.
          </p>

          <div className="bg-white/10 backdrop-blur-md rounded-xl p-4 flex items-center justify-between border border-white/20 relative z-10" data-id="element-2598">
            <div data-id="element-2599">
              <p className="text-[10px] text-white/60 uppercase tracking-wider font-bold mb-1 text-left" data-id="element-2600">
                Your Code
              </p>
              <p className="text-lg font-black tracking-widest text-[#FFD700]" data-id="element-2601">
                SKYDD-ADA26
              </p>
            </div>
            <button className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center hover:bg-white/30 transition-colors" data-id="element-2602">
              <CopyIcon className="w-5 h-5" data-id="element-2603" />
            </button>
          </div>
        </div>

        <button className="w-full bg-[#FFD700] hover:bg-[#F0C900] text-[#0D3B3B] font-bold py-4 rounded-xl transition-all shadow-lg shadow-[#FFD700]/20 active:scale-95 text-lg flex justify-center items-center gap-2" data-id="element-2604">
          <ShareIcon className="w-5 h-5" data-id="element-2605" /> Share Referral Link
        </button>
      </div>
    </motion.div>;
}